import {DISCUSSION_API, REPORT_COMMENT_ERROR} from '../../../constants';

export const reportComment = async ({
    discussionId,
    commentId,
    userId,
    reasonId
}) => {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await fetch(`${DISCUSSION_API}/${discussionId}/comments/${commentId}/flags`, {
            method: 'POST',
            headers: new Headers({
                'x-access-token': user.accessToken,
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                userId,
                reasonId
            })
        });
        if (!response.ok) throw response;
        const responseJson = await response.json();
        return responseJson;
    } catch (error) {
        throw REPORT_COMMENT_ERROR;
    }
};